import { render, staticRenderFns } from "./AdjustSize.vue?vue&type=template&id=6faadf9c&scoped=true"
import script from "./AdjustSize.vue?vue&type=script&lang=js"
export * from "./AdjustSize.vue?vue&type=script&lang=js"
import style0 from "./AdjustSize.vue?vue&type=style&index=0&id=6faadf9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faadf9c",
  null
  
)

export default component.exports